import React from "react";
import "./Linktree.css";
import IMGLOGO from "../../../assets/logo-img.svg";
import { FaFacebookF, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

const Linktree = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <div className="container d-column justify-content-center p-3">
      <div className="d-flex justify-content-center">
        <img className="linktree-image" src={IMGLOGO} alt="" />
      </div>
      <div className="d-flex flex-column justify-content-center mb-4">
        <span className="title-link">@petshopebazarjv</span>
        <span className="subtitle-link">Afeto, Petshop & Qualidade 🐾🧡</span>
      </div>
      <div className="container d-flex justify-content-center">
        <div className={`row ${!matchResult ? "w-50" : "w-100"}`}>
          {/* <a
            className="btn btn-block botao-entrar "
            href="https://agenciabentech.com.br/"
          >
            <div className="container-botao">
              <FaLaptop style={{ marginLeft: "10px" }} />

              <div className="container">Site</div>
            </div>
          </a> */}
          <a
            className="btn btn-block botao-entrar "
            href="https://www.google.com/maps/place/Petshop+Jv/@-22.9330616,-42.8719331,21z/data=!4m5!3m4!1s0x0:0x3e6d81a7dfae782b!8m2!3d-22.9330804!4d-42.8718225"
          >
            <div className="container-botao">
              <FaMapMarkerAlt style={{ marginLeft: "10px" }} />

              <div className="container">Localização</div>
            </div>
          </a>
          <a
            className="btn btn-block botao-entrar "
            href="https://api.whatsapp.com/message/GOUEHRDVMVSBH1?autoload=1&app_absent=0"
          >
            <div className="container-botao">
              <FaWhatsapp style={{ marginLeft: "10px" }} />
              <div className="container">Whatsapp</div>
            </div>
          </a>
          <a
            className="btn btn-block botao-entrar "
            href="https://www.facebook.com/profile.php?id=100087305679299"
          >
            <div className="container-botao">
              <FaFacebookF style={{ marginLeft: "10px" }} />
              <div className="container">Facebook</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Linktree;
